import * as Yup from 'yup';

import i18n from '@/config/i18n';

const { t } = i18n.global;

Yup.setLocale({
  mixed: {
    required: t('Field is required'),
  },
  string: {
    email: t('Invalid email'),
    min: ({ min }) => (t('Field must contain at least {min} characters', { min })),
    max: ({ max }) => (t('Field must not exceed {max} characters', { max })),
    url: t('Field must be a valid URL'),
  },
  number: {
    integer: t('Field must be an integer'),
  },
  array: {
    min: ({ min }) => (t('Field array min size', min, { min })),
    max: ({ max }) => (t('Field must have less than or equal to {max} items', { max })),
  },
});

Yup.addMethod(Yup.array, 'unique', function fn(message, mapper = (a) => a) {
  return this.test('unique', message, (list) => list.length === new Set(list.map(mapper)).size);
});

export default Yup;
